import * as i0 from '@angular/core';
import { Component, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i3 from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from '@angular/material/button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';

var FeedbackFormFields;
(function (FeedbackFormFields) {
    FeedbackFormFields["USER"] = "user";
    FeedbackFormFields["SUBJECT"] = "subject";
    FeedbackFormFields["MESSAGE"] = "message";
})(FeedbackFormFields || (FeedbackFormFields = {}));

function XpoFeedback_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
function XpoFeedback_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1, "Required");
    i0.ɵɵelementEnd();
} }
class XpoFeedback {
    constructor(config, formBuilder, dialogRef) {
        this.formBuilder = formBuilder;
        this.dialogRef = dialogRef;
        this.feedbackFormFields = FeedbackFormFields;
        this.sendingEmail = false;
        this.feedbackConfig = this.mapConfig(config);
    }
    ngOnInit() {
        this.initializeForm();
    }
    hasError(error, field) {
        return this.userFeedbackFormGroup.get(field).hasError(error) && !this.userFeedbackFormGroup.get(field).untouched;
    }
    cancelClicked() {
        this.dialogRef.close(false);
    }
    sendClicked() {
        const formValue = this.userFeedbackFormGroup.getRawValue();
        const message = formValue[FeedbackFormFields.MESSAGE];
        if (this.feedbackConfig.onSendCallback) {
            this.sendingEmail = true;
            this.feedbackConfig.onSendCallback(message).subscribe((result) => {
                if (result) {
                    this.dialogRef.close();
                }
                this.sendingEmail = false;
            });
        }
        else {
            this.dialogRef.close(message);
        }
    }
    mapConfig(config) {
        return {
            disableFromNameInput: config.disableFromNameInput || false,
            disableSubjectInput: config.disableSubjectInput || false,
            fromEmail: config.fromEmail || '',
            fromName: config.fromName || config.fromEmail || '',
            invalidCharacterPattern: config.invalidCharacterPattern || '',
            message: config.message || '',
            onSendCallback: config.onSendCallback,
            subject: config.subject || '',
            title: config.title || 'Feedback',
        };
    }
    initializeForm() {
        this.userFeedbackFormGroup = this.formBuilder.group({
            [FeedbackFormFields.USER]: new FormControl({
                value: this.feedbackConfig.fromName,
                disabled: this.feedbackConfig.disableFromNameInput,
            }, [Validators.required]),
            [FeedbackFormFields.SUBJECT]: new FormControl({
                value: this.feedbackConfig.subject,
                disabled: this.feedbackConfig.disableSubjectInput,
            }, [Validators.required, Validators.pattern(this.feedbackConfig.invalidCharacterPattern)]),
            [FeedbackFormFields.MESSAGE]: new FormControl({
                value: this.feedbackConfig.message,
                disabled: false,
            }, [Validators.required, Validators.pattern(this.feedbackConfig.invalidCharacterPattern)]),
        });
    }
}
XpoFeedback.ɵfac = function XpoFeedback_Factory(t) { return new (t || XpoFeedback)(i0.ɵɵdirectiveInject(MAT_DIALOG_DATA), i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.MatDialogRef)); };
XpoFeedback.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoFeedback, selectors: [["xpo-utils-feedback"]], decls: 19, vars: 7, consts: [[1, "xpo-Feedback", 3, "formGroup"], ["mat-dialog-title", ""], [1, "xpo-Feedback-content"], ["matInput", "", "type", "text", "placeholder", "From", "maxlength", "50", "autocomplete", "off", 3, "formControlName"], ["class", "mat-error", 4, "ngIf"], ["matInput", "", "type", "text", "placeholder", "Subject", "maxlength", "100", "autocomplete", "off", 3, "formControlName"], ["matInput", "", "maxTextareaAutosize", "", "placeholder", "Message", "autocomplete", "off", 3, "formControlName"], [1, "xpo-Feedback-actions"], ["mat-flat-button", "", "tabindex", "-1", 3, "disabled", "click"], [1, "mat-error"]], template: function XpoFeedback_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "h1", 1);
        i0.ɵɵtext(2, " User Feedback ");
        i0.ɵɵelement(3, "xpo-dialog-close-button");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "mat-dialog-content");
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵelementStart(6, "mat-form-field");
        i0.ɵɵelement(7, "input", 3);
        i0.ɵɵelementStart(8, "mat-error");
        i0.ɵɵtemplate(9, XpoFeedback_div_9_Template, 2, 0, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "mat-form-field");
        i0.ɵɵelement(11, "input", 5);
        i0.ɵɵelementStart(12, "mat-error");
        i0.ɵɵtemplate(13, XpoFeedback_div_13_Template, 2, 0, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "mat-form-field");
        i0.ɵɵelement(15, "textarea", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "mat-dialog-actions", 7);
        i0.ɵɵelementStart(17, "button", 8);
        i0.ɵɵlistener("click", function XpoFeedback_Template_button_click_17_listener() { return ctx.sendClicked(); });
        i0.ɵɵtext(18, " Send ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.userFeedbackFormGroup);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("formControlName", ctx.feedbackFormFields.USER);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hasError("required", ctx.feedbackFormFields.USER));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formControlName", ctx.feedbackFormFields.SUBJECT);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hasError("required", ctx.feedbackFormFields.SUBJECT));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formControlName", ctx.feedbackFormFields.MESSAGE);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", !ctx.userFeedbackFormGroup.valid || ctx.sendingEmail);
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i2.MatDialogTitle, i3.XpoDialogCloseButtonComponent, i2.MatDialogContent, i4.MatFormField, i5.MatInput, i1.DefaultValueAccessor, i1.MaxLengthValidator, i1.NgControlStatus, i1.FormControlName, i4.MatError, i6.NgIf, i2.MatDialogActions, i7.MatButton], styles: [".flex--stretch[_ngcontent-%COMP%]{flex:1}.xpo-Feedback[_ngcontent-%COMP%]{width:500px}.xpo-Feedback[_ngcontent-%COMP%]   .mat-dialog-content[_ngcontent-%COMP%]{overflow:hidden}.xpo-Feedback[_ngcontent-%COMP%]   .mat-form-field[_ngcontent-%COMP%]{width:100%}.xpo-Feedback-title[_ngcontent-%COMP%]{margin:16px 16px 0}.xpo-Feedback-actions[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end}.xpo-Feedback-actions[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:last-child{margin-right:8px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFeedback, [{
        type: Component,
        args: [{
                selector: 'xpo-utils-feedback',
                templateUrl: './feedback.component.html',
                styleUrls: ['./feedback.component.scss'],
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: i1.FormBuilder }, { type: i2.MatDialogRef }]; }, null); })();

class XpoFeedbackModule {
}
XpoFeedbackModule.ɵfac = function XpoFeedbackModule_Factory(t) { return new (t || XpoFeedbackModule)(); };
XpoFeedbackModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoFeedbackModule });
XpoFeedbackModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            MatDialogModule,
            MatFormFieldModule,
            MatInputModule,
            ReactiveFormsModule,
            XpoButtonModule,
            XpoDialogModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoFeedbackModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoFeedback],
                imports: [
                    CommonModule,
                    FormsModule,
                    MatDialogModule,
                    MatFormFieldModule,
                    MatInputModule,
                    ReactiveFormsModule,
                    XpoButtonModule,
                    XpoDialogModule,
                ],
                exports: [XpoFeedback],
                entryComponents: [XpoFeedback],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoFeedbackModule, { declarations: [XpoFeedback], imports: [CommonModule,
        FormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        XpoButtonModule,
        XpoDialogModule], exports: [XpoFeedback] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoFeedback, XpoFeedbackModule };
